import React from 'react';


import ProjectCard from '../components/ProjectCard';
import { useLocation } from 'react-router-dom';

import Pet1 from '../images/pet1.png';
import Pet2 from '../images/pet2.png';
import Pet3 from '../images/pet3.png';

import ikuna1 from '../images/ikuna1.png'
import ikuna2 from '../images/ikuna2.png'
import ikuna3 from '../images/ikuna3.png'

import Storefront1 from '../images/storefront1.png';
import Storefront2 from '../images/storefront2.png';
import Storefront3 from '../images/storefront3.png';

const Portfolio = () => {
    const location = useLocation();
    const currentPathname = location.pathname;


    const projectsData = [
        {
            name: 'Biogena Pets',
            desc: 'A modern e-commerce platform for premium pet supplements, designed to educate pet owners and simplify access to veterinarian-developed wellness products. The project enhances product discovery, builds brand trust, and supports healthier lifestyles for pets through a clean, user-friendly experience.',
            liveLink: 'https://biogena-pets.com/de-at',
            image1: Pet3,
            image2: Pet2,
            image3: Pet1,
        },
        {
            name: 'Ikuna',
            desc: 'A digital experience for a family-focused nature resort and adventure park, showcasing activities, attractions, and accommodations. The platform improves visitor engagement, simplifies planning, and drives tourism by clearly communicating the park’s offerings and immersive outdoor experiences.',
            liveLink: 'https://ikuna.at/en',
            image1: ikuna3,
            image2: ikuna1,
            image3: ikuna2,
        },
        {
            name: 'Biogena Biohacking',
            desc: 'A wellness platform promoting advanced biohacking therapies and performance optimization services. The project elevates the brand’s digital presence, educates users on innovative health solutions, and supports user conversion through clear presentation of treatments and benefits.',
            liveLink: 'https://biogena-biohacking.com/de-at',
            image1: Storefront3,
            image2: Storefront2,
            image3: Storefront1,
        },
    ]


    return (
        <section className="portfolio" id='portfolio'>
            <div className="portfolioContainer container">
                <div className="portfolioHeader">
                    <h5>Projects </h5>
                </div>
                {
                    currentPathname === '/' ?
                        projectsData.slice(0, 3).map((projectData, index) => (
                            <ProjectCard projectData={projectData} key={index} />
                        )) : projectsData.map((projectData, index) => (
                            <ProjectCard projectData={projectData} key={index} />
                        ))
                }
            </div>
        </section>
    )
}

export default Portfolio